export function validateRepresenter(payload) {
    const TIPOS_USUARIOS = [
        'representante_varejo', 
        'gerente_regional',
        'gerente_distrital',
        'analista_farma',
        'gestor',
        'preposto',
        'gerente_varejo',
        'gerente_nacional',
        'diretor_nacional'
    ];

    return (rule, value, callback) => {
        if (TIPOS_USUARIOS.includes(payload.tipo_usuario) && !value) {
            callback(new Error('O representante é obrigatório'));
        } 

        callback();
    }
}

export function validateRepresenterPrepo(payload) {
    return (rule, value, callback) => {
        if (payload.tipo_usuario == 'preposto' && !value) {
            callback(new Error('O representante para o preposto é obrigatório'));
        } 

        callback();
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/schemas/userSchema.js